module.exports = __webpack_public_path__ + "static/media/loading.548b665a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.svg
// module id = 1103
// module chunks = 1